import { saveChatSession } from './saveChatSession'

/** @type {ChatSession} */
const newSession = {
  chatId: '',
  chatActive: false,
  conversation: [],
  groupId: 13,
  rating: -1,
  users: [],
  welcomeMessage:
    "Hi! Your results are ready! What's your full name so I can pull up your form?",
}

/**
 * Saves Chat Session
 * @returns {ChatSession}
 */
export function getChatSession() {
  const data = localStorage.getItem('TD_LC_CHAT_SESSION')

  if (!data) {
    saveChatSession(newSession)
    return newSession
  }

  const session = {
    ...newSession,
    ...JSON.parse(data),
  }

  return /** @type {ChatSession} */ (session)
}
